// extracted by mini-css-extract-plugin
export var lg = "_gt-7";
export var md = "_gt-6";
export var placeholderContainer = "_gt-1";
export var placeholderIcon = "_gt-2";
export var productImage = "_gt-0";
export var sm = "_gt-5";
export var xl = "_gt-8";
export var xs = "_gt-4";
export var xxs = "_gt-3";